import { forwardRef, type ReactNode, type HTMLAttributes } from 'react';
import { useTheme } from '@vitness/theme';

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export const Tag = forwardRef<HTMLSpanElement, TagProps>(function Tag(
  { children, style, ...props },
  ref,
) {
  const { mode } = useTheme();

  return (
    <span
      ref={ref}
      style={{
        fontFamily: 'var(--vn-font-mono)',
        fontSize: 9,
        padding: '2px 6px',
        borderRadius: 3,
        background: mode === 'light' ? '#EBEBEA' : 'rgba(255,255,255,0.04)',
        border: '1px solid var(--vn-border-default)',
        color: 'var(--vn-text-muted)',
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...props}
    >
      {children}
    </span>
  );
});
